<mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Organization</mat-label>
    <input matInput placeholder="Select Organization" [matAutocomplete]="organization" [formControl]="_form">
</mat-form-field>
<mat-autocomplete #organization="matAutocomplete" [displayWith]="displayFn"
    (optionSelected)="OnOrganizationSelect($event.option.value)">
    <mat-option *ngIf="IsLoading$ | async">
        <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
    </mat-option>
    <ng-container *ngIf="!(IsLoading$ | async)">
        <mat-option *ngFor="let org of FilteredOrganization$ | async" [value]="org">
            {{ org.name }}
        </mat-option>
    </ng-container>
</mat-autocomplete>